// hd-redesign-p1 — the hero slider.
//
// Ported from the export's applyHero/step/goDot. Three facts carried verbatim:
//   · the transition is .68s cubic-bezier(.5,.05,.2,1)  (CSS, hd-p1.css)
//   · autoplay is a 5000ms interval
//   · the track offset is computed from window.innerWidth, matching the slide's
//     own `width: 100vw`. It read Math.max(1440, innerWidth) while the export's
//     desktop floor was in force; with the floor gone the max() would have
//     pinned the hero at 1440 on a phone while every other section reflowed.
//     AT AND ABOVE 1440 THE TWO EXPRESSIONS ARE THE SAME NUMBER, which is what
//     makes this safe against the frozen desktop.
//
//     innerWidth, not clientWidth: it counts the scrollbar and so does 100vw, so
//     the slide's width and the offset that moves it stay in agreement.
//
// Under reduced motion there is no autoplay and jumps are instant: the CSS
// duration is already clamped to 1ms by the global guard, and the interval is
// simply never created. Nothing here animates on its own.
//
// THE SIGN IS READ, NOT ASSUMED. `transform` is physical -- translateX(+X) is
// physical right with no writing-mode mapping, the same fact assets/hd-cart.css
// :232-258 records for the drawer. .hd-p1-hero__track is a flex row, so under
// dir="rtl" slide 2 lays out to the LEFT of slide 1 and a negative translate
// drives the track AWAY from the viewport: on the Arabic storefront -- this
// store's primary and default locale -- every advance showed bare ground. The
// direction is read off the element with getComputedStyle, which is the shape
// assets/hd-before-after.js:68-76 already uses and which keeps working inside
// the theme editor, where the document may be re-rendered under the section.
(function () {
  "use strict";

  function init(root) {
    var track = root.querySelector("[data-hero-track]");
    var dots = Array.prototype.slice.call(root.querySelectorAll("[data-hero-dot]"));
    if (!track || !dots.length) return;

    var count = dots.length;
    var index = 0;
    var timer = null;
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)");

    function apply() {
      var sign = window.getComputedStyle(track).direction === "rtl" ? 1 : -1;
      track.style.transform =
        "translateX(" + sign * index * window.innerWidth + "px)";
      dots.forEach(function (d, i) {
        d.setAttribute("aria-current", i === index ? "true" : "false");
      });
    }

    function go(i) {
      index = ((i % count) + count) % count;
      apply();
    }

    function start() {
      if (reduced.matches) return;
      stop();
      timer = window.setInterval(function () {
        go(index + 1);
      }, 5000);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    dots.forEach(function (d, i) {
      d.addEventListener("click", function () {
        go(i);
        // The export restarts the clock on a dot click so a deliberate choice
        // is not overwritten a fraction of a second later.
        if (timer) start();
      });
    });

    window.addEventListener("resize", apply);
    // A tab in the background throttles timers and banks nothing useful; the
    // export leaves the interval running, but pausing avoids a burst of queued
    // advances on return.
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop();
      else if (!reduced.matches) start();
    });

    apply();
    start();

    root.addEventListener("hd:teardown", stop);
  }

  function boot(scope) {
    Array.prototype.slice
      .call((scope || document).querySelectorAll("[data-hero-root]"))
      .forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  // Theme-editor lifecycle: the section is replaced wholesale on every save.
  document.addEventListener("shopify:section:load", function (e) {
    boot(e.target);
  });
  document.addEventListener("shopify:section:unload", function (e) {
    var root = e.target.querySelector("[data-hero-root]");
    if (root) root.dispatchEvent(new CustomEvent("hd:teardown"));
  });
})();
